"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _ToolTip = _interopRequireDefault(require("./tooltip/ToolTip"));

var _Markdown = _interopRequireDefault(require("./text/Markdown"));

var _styling = require("../toolkit/styling");

var _device = require("../toolkit/device");

var _providers = require("../toolkit/providers");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DefaultThemeWrapper = function DefaultThemeWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

var Popover = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    (0, _classCallCheck2["default"])(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "mouseOver", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "clickOn", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "popupRef", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "loading", _descriptor4, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "clicked", _descriptor5, (0, _assertThisInitialized2["default"])(_this));
    _this.classNamePrefix = "popoverv2_ref";
    _this.groupId = _lodash["default"].uniqueId();
    _this.timer = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Popover, [{
    key: "popoverContent",
    value: function popoverContent() {
      var _this$props = this.props,
          popoverContent = _this$props.popoverContent,
          popoverIcon = _this$props.popoverIcon,
          themeWrapper = _this$props.themeWrapper,
          openContentLinksInNewTab = _this$props.openContentLinksInNewTab;
      var ThemeWrapper = themeWrapper || DefaultThemeWrapper;

      if (typeof popoverContent === "string") {
        if (popoverContent.trim().length === 0) {
          return null;
        }

        if (typeof popoverIcon === "string") {
          return /*#__PURE__*/_react["default"].createElement(ThemeWrapper, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _styling.css)(this.styles.richPopoverContent)
          }, /*#__PURE__*/_react["default"].createElement("img", {
            src: popoverIcon,
            className: (0, _styling.css)(this.styles.popoverIcon),
            draggable: "false",
            alt: "dispute status icon"
          }), /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
            className: (0, _styling.css)(this.styles.popoverText),
            text: popoverContent,
            openLinksInNewTab: openContentLinksInNewTab
          })));
        }

        return /*#__PURE__*/_react["default"].createElement(ThemeWrapper, null, /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
          className: (0, _styling.css)(this.styles.popoverContent),
          text: popoverContent,
          openLinksInNewTab: openContentLinksInNewTab
        }));
      }

      if (typeof popoverContent === "function") {
        return /*#__PURE__*/_react["default"].createElement(ThemeWrapper, null, popoverContent());
      }

      return null;
    }
  }, {
    key: "getTooltipPosition",
    value: function getTooltipPosition() {
      var position = this.props.position;

      if (position) {
        var popupArrowPosition = position.split(" ");

        if (popupArrowPosition.length === 2) {
          return {
            position: popupArrowPosition[0],
            arrow: popupArrowPosition[1]
          };
        }

        return {
          position: popupArrowPosition[0],
          arrow: "center"
        };
      }

      return {
        position: "top",
        arrow: "center"
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          popoverOpen = _this$props2.popoverOpen,
          popoverFontSize = _this$props2.popoverFontSize,
          popoverContent = _this$props2.popoverContent,
          popoverMaxWidth = _this$props2.popoverMaxWidth,
          contentWidth = _this$props2.contentWidth,
          popoverIcon = _this$props2.popoverIcon,
          children = _this$props2.children,
          popoverMouseEnterDelay = _this$props2.popoverMouseEnterDelay,
          disableMouseOverTrigger = _this$props2.disableMouseOverTrigger,
          popoverMinWidth = _this$props2.popoverMinWidth,
          _this$props2$on = _this$props2.on,
          on = _this$props2$on === void 0 ? "hover" : _this$props2$on,
          themeWrapper = _this$props2.themeWrapper,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["popoverOpen", "popoverFontSize", "popoverContent", "popoverMaxWidth", "contentWidth", "popoverIcon", "children", "popoverMouseEnterDelay", "disableMouseOverTrigger", "popoverMinWidth", "on", "themeWrapper"]);

      var deviceStore = _device.DeviceStore.instance();

      var popoverContentValue = this.popoverContent();
      var classList = [this.classNamePrefix, this.styles.triggerContainer, this.groupId];

      if (popoverContentValue === null) {
        return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
          className: (0, _styling.css)([].concat(classList))
        }, props), children);
      }

      var popupArrowPosition = this.getTooltipPosition();

      var clearTimeoutIfPresent = function clearTimeoutIfPresent() {
        if (_this2.timer != null) {
          clearTimeout(_this2.timer);
          _this2.timer = null;
        }
      };

      var tooltipOpen = deviceStore.isSmallScreen || on == "click" ? this.clickOn : this.mouseOver;
      tooltipOpen = popoverOpen || tooltipOpen;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _styling.css)([].concat(classList)),
        ref: function ref(_ref2) {
          if (_this2.popupRef === "#content" && _ref2 != null) {
            _this2.popupRef = _ref2;
          }
        }
      }, props, {
        onMouseEnter: function onMouseEnter(event) {
          var e = event.toElement || event.relatedTarget;

          if (_this2.popupRef && e && e.parentNode) {
            var evtClassName = e.parentNode.className;

            if (evtClassName && typeof evtClassName.slice === "function" && evtClassName.slice(0, _this2.classNamePrefix.length) === _this2.classNamePrefix && evtClassName.slice(_this2.classNamePrefix.length) !== _this2.groupId) {
              return;
            }
          }

          clearTimeoutIfPresent();

          if (!disableMouseOverTrigger) {
            // @ts-ignore: weird inconsistency between `ttsc` and babel
            // `ttsc` agrees with this expression but babel TS plugin
            // doesn't. Suppress both as the logic is functionally sound.
            _this2.timer = setTimeout(function () {
              _this2.mouseOver = true;
            }, popoverMouseEnterDelay);
          } // Stop Popover from closing itself when loaded for the first time on a page


          if (_this2.loading && on == "click" && _this2.clicked) {
            _this2.clickOn = true;
          }
        },
        onMouseLeave: function onMouseLeave() {
          clearTimeoutIfPresent();
          _this2.mouseOver = false;
          _this2.clickOn = false; // Stop Popover from closing itself when loaded for the first time on a page

          if (_this2.loading && on == "click" && _this2.clicked) {
            setTimeout(function () {
              _this2.loading = false;
            }, 500);
          }
        },
        onClick: function onClick() {
          _this2.clickOn = true; // Stop Popover from closing itself when loaded for the first time on a page

          _this2.clicked = true;
        }
      }), children), /*#__PURE__*/_react["default"].createElement(_ToolTip["default"] // @ts-ignore - ToolTip component copied from pre-TypeScript open-source, still uses PropTypes
      , {
        position: popupArrowPosition.position,
        arrow: popupArrowPosition.arrow,
        active: popoverOpen != null ? popoverOpen : tooltipOpen,
        parent: this.popupRef,
        tooltipTimeout: 200,
        group: this.groupId,
        contentWidth: contentWidth,
        isManualControl: popoverOpen != null
      }, popoverContentValue));
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$props3 = this.props,
          paddingContentPadding = _this$props3.paddingContentPadding,
          popoverFontSize = _this$props3.popoverFontSize,
          popoverMaxWidth = _this$props3.popoverMaxWidth,
          popoverMinWidth = _this$props3.popoverMinWidth,
          _this$props3$popoverW = _this$props3.popoverWhitespace,
          popoverWhitespace = _this$props3$popoverW === void 0 ? "normal" : _this$props3$popoverW;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          textBlack = _this$context$theming2.textBlack,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          fonts = _this$context$theming.fonts;
      var iconFrames = {
        from: {
          transform: "scale3d(0, 0, 0)",
          opacity: 0
        },
        to: {
          transform: "scale3d(1, 1, 1)",
          opacity: 1
        }
      };
      var popoverkeyframes = {
        from: {
          transform: "translate3d(0, 10px, 0)",
          opacity: 0
        },
        to: {
          transform: "translate3d(0, 0, 0)",
          opacity: 1
        }
      };
      return _aphrodite.StyleSheet.create({
        popoverContent: {
          fontSize: popoverFontSize || 14,
          lineHeight: 1.5,
          color: textBlack,
          fontFamily: fonts.regular,
          padding: paddingContentPadding || 13,
          maxWidth: popoverMaxWidth,
          minWidth: popoverMinWidth,
          textAlign: "left",
          whiteSpace: popoverWhitespace,
          opacity: 1
        },
        richPopoverContent: {
          fontFamily: fonts.regular,
          display: "flex",
          textAlign: "left",
          flexDirection: "row",
          alignItems: "center",
          borderRadius: 4,
          backgroundColor: surfaceLightest,
          padding: 15,
          maxWidth: popoverMaxWidth,
          minWidth: popoverMinWidth,
          opacity: 1
        },
        popoverIcon: {
          width: 30,
          minWidth: 30,
          marginRight: 10,
          alignSelf: "flex-start",
          animationName: [iconFrames],
          animationDuration: "250ms",
          opacity: 1
        },
        popoverText: {
          fontSize: popoverFontSize || 14,
          fontFamily: fonts.regular,
          whiteSpace: popoverWhitespace,
          animationName: [popoverkeyframes],
          color: textBlack,
          animationDuration: "450ms",
          opacity: 1
        },
        triggerContainer: {
          display: "flex",
          alignItems: "stretch",
          flexDirection: "column",
          ":nth-child(1n) > div": {
            flexGrow: 1
          }
        }
      });
    }
  }]);
  return Popover;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.defaultProps = {
  popoverFontSize: 14,
  popoverMouseEnterDelay: 0,
  disableMouseOverTrigger: false
}, _class3.propDoc = {
  popoverContent: {
    required: false,
    defaultValue: "null",
    type: "(string | null) | ((() => ReactNode))",
    description: "This value will be used as the popover content. " + "Pass in a string if the content of the popover is purely text. " + "If the popover has custom content, pass in a render function."
  },
  popoverFontSize: {
    required: false,
    defaultValue: "null",
    type: "number",
    description: "Font size of the popover text"
  },
  popoverMaxWidth: {
    required: false,
    defaultValue: "null",
    type: "number",
    description: "Optional maxWidth for the popover"
  },
  popoverOpen: {
    required: false,
    defaultValue: "null",
    type: "boolean",
    description: "If popover should be forced open. " + "It will dictate the opening logic of the popover if given."
  },
  openContentLinksInNewTab: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "If this prop is set to true, and the popover content was passed in as a string, then " + "any links in the popover content will be opened in a new tab."
  }
}, _class3.demoProps = [{
  demoDescription: "Open Links in New Tab",
  popoverContent: "This is an example of opening a link in a new tab! [Learn More](staging.merchant.wish.com).",
  position: "bottom center",
  popoverMaxWidth: 200,
  openContentLinksInNewTab: true,
  popoverOpen: true
}, {
  demoDescription: "Do Not Open Links in New Tab",
  popoverContent: "This is an example of opening a link in this tab! [Learn More](staging.merchant.wish.com).",
  position: "bottom center",
  popoverMaxWidth: 200,
  openContentLinksInNewTab: false,
  popoverOpen: true
}], _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "mouseOver", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "clickOn", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "popupRef", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "#content";
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "loading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "clicked", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Popover;
exports["default"] = _default;